import { Stack } from "@mui/material";
import "azure-maps-control/dist/atlas.min.css";

import Datetime from "@/common/components/Datetime/Datetime";
import FieldValue from "@/common/components/Form/Display/FieldValue";
import GeolocationPointDisplay from "@/common/components/Geolocation/GeolocationPointDisplay";
import { GeoHelper } from "@/common/helpers/geo";
import { TypeHelper } from "@/common/helpers/type";
import { GeneralGeolocationDto } from "@/core/api/generated/v1";

import GeneralByWhoDisplay from "../Display/GeneralByWhoDisplay";

interface Props {
  value: Nil<GeneralGeolocationDto>;
}

export default function GeneralGeolocationDisplay({ value }: Props) {
  if (!value?.point) {
    return null;
  }

  return (
    <Stack>
      <GeolocationPointDisplay value={value.point} />

      <FieldValue label='Coordinates' direction='row' isEmpty={TypeHelper.isEmpty(value.point)}>
        {value.point &&
          GeoHelper.getCoordinatesAsString({
            longitude: value.point.longitude,
            latitude: value.point.latitude,
          })}
      </FieldValue>

      <FieldValue
        label='Captured at'
        direction='row'
        isEmpty={TypeHelper.isEmpty(value.capturedAt)}
      >
        <Datetime datetime={value.capturedAt} />
      </FieldValue>

      <FieldValue label='Updated at' direction='row' isEmpty={TypeHelper.isEmpty(value.updatedAt)}>
        <Datetime datetime={value.updatedAt} />
      </FieldValue>

      <FieldValue label='Updated by' direction='row' isEmpty={TypeHelper.isEmpty(value.updatedBy)}>
        <GeneralByWhoDisplay who={{ userId: value.updatedBy }} />
      </FieldValue>
    </Stack>
  );
}
